let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "500",
        trackFullPrice: '800',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1677682725829x638745113282478100',
        // earlyBird: true,
    },
    {
        trackTitle: "NO RECORDINGS access",
        trackSubtitle: "For Junior specialists",
        trackPrice: "350",
        trackNextPrice: "400",
        trackFullPrice: '500',
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1679301952442x465352911709274100',
        // earlyBird: true,
    },
    {
        trackTitle: `AI in QA and Testing'23
+`,
        secondEvent: "QA Global Summit'23",
        secondEventLink: "https://events.geekle.us/qa/",
        trackPrice: "800",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Two Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1685701091860x724627884152717300',
    },
    {
        trackTitle: "ChatGPT best practices Package",
        event1: "AI in QA and Testing Conference'23",
        event2: "GPTcoding for Frontend Developers Conference'23",
        event2Link: "https://events.geekle.us/gpt/",
        event3: "GPTcoding for Backend Developers Summit’23",
        event3Link: "https://events.geekle.us/gpt-backend/",
        trackPrice: "1200",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1685964293836x659849386307092500',
        validDate: '9.06',
        inverseColors: true,
    },
];

export default PackagesItem;
